import type { SidebarSectionTextComponent } from "@productlane/api/src/browser"
import { cn } from "@productlane/lib/src/cn"

interface Props {
	component: SidebarSectionTextComponent
}

const ColorMapping: Record<SidebarSectionTextComponent["color"], string> = {
	normal: "text-primary",
	muted: "text-secondary",
}
// Capped at text-sm so a connector cannot blow up the sidebar's type scale.
const SizeMapping: Record<SidebarSectionTextComponent["size"], string> = {
	s: "text-[11px]",
	m: "text-xs",
	l: "text-sm font-medium",
}

export function TextComponent({ component }: Props) {
	return (
		<div
			className={cn(
				"w-full",
				ColorMapping[component.color],
				SizeMapping[component.size],
			)}
		>
			{component.text}
		</div>
	)
}
